'use strict';

exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _createReactClass = require('create-react-class');

var _createReactClass2 = _interopRequireDefault(_createReactClass);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Layout = require('./Layout');

var _Layout2 = _interopRequireDefault(_Layout);

var _Log = require('./Log');

var _Log2 = _interopRequireDefault(_Log);

var _RenderCode = require('./RenderCode');

var _RenderCode2 = _interopRequireDefault(_RenderCode);

exports['default'] = _createReactClass2['default']({

  displayName: 'Demo.Controls',

  propTypes: {
    values: _propTypes2['default'].object.isRequired,
    logs: _propTypes2['default'].object.isRequired,
    props: _propTypes2['default'].object.isRequired,
    onChange: _propTypes2['default'].func.isRequired,
    targetEl: _propTypes2['default'].node.isRequired,
    onTop: _propTypes2['default'].bool.isRequired,
    codeIndentDepth: _propTypes2['default'].number.isRequired
  },

  handleChange: function handleChange(key) {
    var _this = this;

    return function (nextValue) {
      var _extends2;

      var _props = _this.props;
      var onChange = _props.onChange;
      var values = _props.values;

      onChange(_extends({}, values, (_extends2 = {}, _extends2[key] = nextValue, _extends2)));
    };
  },

  renderLog: function renderLog(key) {
    return _react2['default'].createElement(_Log2['default'], { key: key, name: key, items: this.props.logs[key] });
  },

  renderControl: function renderControl(key) {
    var _props2 = this.props;
    var props = _props2.props;
    var values = _props2.values;

    var Control = props[key].Control;
    var controlProps = props[key].controlProps || {};
    var value = values[key];
    return _react2['default'].createElement(Control, _extends({}, controlProps, {
      key: key,
      name: key,
      value: value,
      onChange: this.handleChange(key)
    }));
  },

  render: function render() {
    var _props3 = this.props;
    var onTop = _props3.onTop;
    var targetEl = _props3.targetEl;
    var codeIndentDepth = _props3.codeIndentDepth;
    var props = _props3.props;
    var logs = _props3.logs;

    return _react2['default'].createElement(
      _Layout2['default'],
      { onTop: onTop },
      _react2['default'].createElement(_RenderCode2['default'], { obj: targetEl, indentDepth: codeIndentDepth }),
      Object.keys(props).map(this.renderControl),
      Object.keys(logs).map(this.renderLog)
    );
  }

});
module.exports = exports['default'];